var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('radio-list',{attrs:{"name":'warehouse',"items":_vm.rubrics},model:{value:(_vm.rubric),callback:function ($$v) {_vm.rubric=$$v},expression:"rubric"}}),_c('keep-alive',[_c(_vm.rubric,{tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }